<template>
  <ul class="nav justify-content-start lasubnav d-flex flex-wrap align-items-center py-1">
    <li class="nav-item">
      <router-link :to="listLink" class="nav-link text-white" active-class="active">Pedidos</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="usersLink" class="nav-link text-white" active-class="active">Usuarios</router-link>
    </li>
    <li class="nav-item">
      <router-link :to="catalogosLink" class="nav-link text-white" active-class="active">Catálogos</router-link>
    </li>
    <BranchofficeSelect v-if="getHasPermission" />
  </ul>
</template>

<script>
import BranchofficeSelect from "./../sub-components/branchoffice-select.vue";
export default {
  components: {
    BranchofficeSelect
  },
  data : function () { 
    return {
      hasPermission : false
    }
  },
  computed: {
    getHasPermission() {
        return this.hasPermission
    },
    listLink() {
      return { name: 'Pedidos Ecommerce' }
    },
    usersLink() {
      return { name: 'Usuarios Ecommerce' }
    },
    catalogosLink() {
      return { name: 'Catalogos' }
    },
  },
  methods: {
    getAllBranchofficesFundsPermission() {
      this.$http
        .get("/api/configs/role/permissions/names", {
           headers: { 
            Authorization: "Bearer " + localStorage.getItem("token")
          },
        })
        .then((response) => {
          this.hasPermission = response.data.data.includes('ACCESS_ALL_BRANCHOFFICES_FUNDS');
        })
    },
  },
  created() {
    this.getAllBranchofficesFundsPermission();
  },
}
</script>

<style scoped>
.lasubnav {
  animation: opacity 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
  background: #2d538a;
  /* justify-content-start fijo (no solo mientras carga el selector de
     sucursal) para que no haya salto de layout al montar/desmontar. */
  padding-left: 1rem;
}

.lasubnav .nav-link {
  padding: 11px;
  color: white;
  font-weight: bold;
}

.lasubnav .nav-link:not(.active) {
  font-weight: normal;
  letter-spacing: 0.01em;
}

.lasubnav .nav-link:hover,
.lasubnav .nav-link:focus {
  color: white;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.active {
  font-weight: bold;
  color: white; 
  background-color: #4477bd;
  border-radius: 4px;
}
</style>